
import Vue, { PropType } from 'vue';
import { Runnit, CompanyCustomFieldDef, RUNNIT_TYPE } from '@run-diffusion/shared';
import { mapState, mapActions } from 'vuex';
import { RUNNITS_OWNER_SELECTION } from '@/views/Runnits/constants';
import { isWithinLimitNumRunnits } from '@/store/utils';
import RunnitImage from '@/views/Runnits/RunnitImage.vue';
import RunnitBoardMembersTableCell from './RunnitBoardMembersTableCell.vue';
import RunnitBoardOwnerTableCell from './RunnitBoardOwnerTableCell.vue';
import ClipboardCopy from '@/components/ClipboardCopy.vue';
import ManageRunnitMenuBtn from '@/views/Runnits/ManageRunnitMenuBtn.vue';
import { BoardLiveState } from './boardsListState';

export default Vue.extend({
	name: 'RunnitBoardRow',
	props: {
		runnit: {
			type: Object as () => Runnit,
			required: true,
		},
		// Added on this page and shown ahead of the listing (utils/justAdded.ts)
		justAdded: { type: Boolean, default: false },
		// Where the row's own Firestore binding has got to (RunnitBoardLiveDoc).
		// Until it is live, `runnit` is a stand-in built from the Postgres row.
		liveState: {
			type: String as PropType<BoardLiveState>,
			default: 'live',
		},
	},
	data () {
		return {
			RUNNITS_OWNER_SELECTION,
			RUNNIT_TYPE,
		};
	},
	computed: {
		...mapState([
			'user',
			'team',
			'runnitState',
		]),
		runnitCustomFieldDefs (): CompanyCustomFieldDef[] {
			return this.team?.company?.runnitCustomFieldDefs || [];
		},
		isTemplate (): boolean {
			return this.runnit?.type === RUNNIT_TYPE.TEMPLATE;
		},
		isAbovePlanRunnitsLimit (): boolean {
			if (this.isTemplate) return false;
			return !isWithinLimitNumRunnits(this.$store.state, this.runnit.id);
		},
		// Deleted, or moved off this account, since the list was fetched
		isRemoved (): boolean {
			return this.liveState === 'removed';
		},
	},
	methods: {
		...mapActions([
			'setUpsellDialog',
		]),
		onRowClick () {
			if (this.isAbovePlanRunnitsLimit || this.isRemoved) return;
			this.onOpenRunnit();
		},
		onOpenRunnit () {
			this.$emit('open-runnit', this.runnit);
		},
	},
	components: {
		RunnitImage,
		RunnitBoardMembersTableCell,
		RunnitBoardOwnerTableCell,
		ClipboardCopy,
		ManageRunnitMenuBtn,
	},
});
